import { render, staticRenderFns } from "./StaffListAddNew.vue?vue&type=template&id=c1783cbc"
import script from "./StaffListAddNew.vue?vue&type=script&lang=js"
export * from "./StaffListAddNew.vue?vue&type=script&lang=js"
import style0 from "./StaffListAddNew.vue?vue&type=style&index=0&id=c1783cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports